import { ReportReducerState } from './types';

export const initialState: ReportReducerState = {
  list: null,
  total: 0,
  starredPresent: false,
  appliedFilters: {},
  // @ts-ignore
  detailsTargetActivity: null,
  activityDetailsData: null,
  taskStatuses: [
    { documentType: 0, status: 0, rejectedReason: null, rejectionDate: null },
    { documentType: 1, status: 0, rejectedReason: null, rejectionDate: null },
    { documentType: 2, status: 0, rejectedReason: null, rejectionDate: null },
  ],
};
